// import { useEffect, useState } from "react";
// import { db } from "../../firebase"; // Firebase конфігурація
// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import css from "./adm.module.css";

// export default function AdminAboutAuth() {
//   const [content, setContent] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
//       const docSnap = await getDoc(docRef);

//       if (docSnap.exists()) {
//         setContent(docSnap.data()); // Якщо документ існує
//       } else {
//         alert("Документ не існує! Буде створено новий документ.");
//         setContent({
//           section1_intro: "",
//           section1_general: "",
//           section1_desc: "",
//           section1_offer: "",
//           section2_intronew: "",
//           section2_intro: "",
//           section2_post: "",
//           section2_general: "",
//           section2_desc: "",
//         });
//       }
//       setLoading(false);
//     };

//     fetchData();
//   }, []);

//   const handleChange = (field, value) => {
//     setContent((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSave = async () => {
//     const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
//     try {
//       // Якщо документ існує, оновити; якщо ні, створити новий
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists()) {
//         await updateDoc(docRef, content);
//       } else {
//         await setDoc(docRef, content);
//       }
//       alert("Збережено успішно!");
//     } catch (error) {
//       console.error("Помилка при збереженні документа: ", error);
//       alert("Помилка збереження. Перевірте консоль для деталей.");
//     }
//   };

//   if (loading) return <div>Завантаження...</div>;

//   return (
//     <div>
//       <h1>Редагування текстів AboutAuth</h1>
//       <form>
//         {/* Поля для авторів */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Вступ для авторів</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_intro || ""}
//             onChange={(value) => handleChange("section1_intro", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Загальне звернення до автора</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_general || ""}
//             onChange={(value) => handleChange("section1_general", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Опис для авторів</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_desc || ""}
//             onChange={(value) => handleChange("section1_desc", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Оферта</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_offer || ""}
//             onChange={(value) => handleChange("section1_offer", value)}
//           />
//         </div>

//         {/* Нове поле */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Повага</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_intronew || ""}
//             onChange={(value) => handleChange("section2_intronew", value)}
//           />
//         </div>

//         {/* Поля для художників */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Вступ для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_intro || ""}
//             onChange={(value) => handleChange("section2_intro", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Email для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_post || ""}
//             onChange={(value) => handleChange("section2_post", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Загальне звернення до художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_general || ""}
//             onChange={(value) => handleChange("section2_general", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Опис для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_desc || ""}
//             onChange={(value) => handleChange("section2_desc", value)}
//           />
//         </div>

//         {/* Кнопка збереження */}
//         <button type="button" onClick={handleSave}>
//           Зберегти зміни
//         </button>
//       </form>
//     </div>
//   );
// }
// src/components/admin/AdminAboutAuth.jsx
// AdminAboutAuth.jsx (pure React)
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  ABOUT_AUTH_DEFAULT_CONTENT,
  ABOUT_AUTH_PLAIN_FIELDS,
  ABOUT_AUTH_RICH_FIELDS,
  prepareAboutAuthContent,
  resolveAboutAuthContent,
} from "../../content/aboutAuthContent";
import css from "./autorAndHud.module.css";

/* === Quill toolbar / formats (поза компонентом) === */
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ align: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["blockquote", "code-block"],
    ["link", "image", "clean"],
  ],
  clipboard: { matchVisual: false },
  history: { delay: 500, maxStack: 100, userOnly: true },
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "align",
  "list",
  "indent",
  "blockquote",
  "code-block",
  "link",
  "image",
];

/* === Простий підкомпонент без хуків === */
function Editor({ value, onChange, placeholder, className, disabled }) {
  return (
    <ReactQuill
      className={className}
      theme="snow"
      value={value || ""}
      onChange={onChange}
      readOnly={disabled}
      modules={quillModules}
      formats={quillFormats}
      placeholder={placeholder}
    />
  );
}

export default function AdminAboutAuth() {
  const [content, setContent] = useState(ABOUT_AUTH_DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
        const snap = await getDoc(docRef);
        if (!isMounted) return;
        if (snap.exists()) {
          setContent(resolveAboutAuthContent(snap.data()));
        } else {
          setContent(ABOUT_AUTH_DEFAULT_CONTENT);
        }
      } catch (e) {
        console.error("Не вдалося завантажити тексти сторінки:", e);
        if (isMounted) {
          setStatus({ type: "error", text: "Не вдалося завантажити тексти." });
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleChange = (field, value) => {
    setStatus(null);
    setContent((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (saving) return;
    setSaving(true);
    setStatus(null);
    try {
      const preparedContent = prepareAboutAuthContent(content);
      const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
      await setDoc(docRef, preparedContent, { merge: true });
      setContent(preparedContent);
      setStatus({ type: "success", text: "Зміни збережено." });
    } catch (e) {
      console.error("Помилка при збереженні:", e);
      setStatus({
        type: "error",
        text: e?.message || "Не вдалося зберегти зміни.",
      });
    } finally {
      setSaving(false);
    }
  };

  const renderPlainFields = (group) =>
    ABOUT_AUTH_PLAIN_FIELDS.filter((field) => field.group === group).map(
      ({ key, label, type, maxLength }) => {
        const Input = type === "textarea" ? "textarea" : "input";
        return (
          <label className={css.field} htmlFor={`about-auth-${key}`} key={key}>
            <span>{label}</span>
            <Input
              id={`about-auth-${key}`}
              className={type === "textarea" ? css.textarea : css.input}
              value={content[key]}
              maxLength={maxLength}
              disabled={saving}
              onChange={(event) => handleChange(key, event.target.value)}
            />
            <small>
              {content[key].length}/{maxLength}
            </small>
          </label>
        );
      }
    );

  const renderRichFields = (group) =>
    ABOUT_AUTH_RICH_FIELDS.filter((field) => field.group === group).map(
      ({ key, label, placeholder }) => (
        <div className={css.editorBlock} key={key}>
          <h3>{label}</h3>
          <Editor
            className={css.editor}
            value={content[key]}
            onChange={(value) => handleChange(key, value)}
            placeholder={placeholder}
            disabled={saving}
          />
        </div>
      )
    );

  if (loading) return <div className={css.loading}>Завантаження...</div>;

  return (
    <div className={css.page}>
      <h1>Сторінка «Для авторів / Для художників»</h1>
      <p className={css.description}>
        Тут редагуються всі написи та основні тексти сторінки.
      </p>

      <form
        className={css.form}
        onSubmit={(event) => {
          event.preventDefault();
          handleSave();
        }}
      >
        <section className={css.section}>
          <h2>Кнопки переходу</h2>
          <div className={css.fieldGrid}>{renderPlainFields("navigation")}</div>
        </section>

        <section className={css.section}>
          <h2>Для авторів</h2>
          <div className={css.fieldGrid}>{renderPlainFields("author")}</div>
          {renderRichFields("author")}
        </section>

        <section className={css.section}>
          <h2>Для художників</h2>
          <div className={css.fieldGrid}>{renderPlainFields("artist")}</div>
          {renderRichFields("artist")}
        </section>

        <div className={css.actions}>
          <button type="submit" className={css.saveButton} disabled={saving}>
            {saving ? "Збереження..." : "Зберегти зміни"}
          </button>
          {status && (
            <p
              className={status.type === "error" ? css.error : css.success}
              role="status"
              aria-live="polite"
            >
              {status.text}
            </p>
          )}
        </div>
      </form>
    </div>
  );
}
